"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { Turnstile, type TurnstileInstance } from "@marsidev/react-turnstile";
const WIDGET_WIDTH = 300;
const WIDGET_HEIGHT = 65;
type ResponsiveTurnstileProps = {
  siteKey: string;
  onSuccess?: (token: string) => void;
  onExpire?: () => void;
};
export default function ResponsiveTurnstile(t0) {
  const $ = _c(22);
  const {
    siteKey,
    onSuccess,
    onExpire
  } = t0;
  const widgetRef = useRef(undefined);
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [isNearViewport, setIsNearViewport] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const container = containerRef.current;
      if (!container) {
        return;
      }
      const updateScale = () => {
        setScale(Math.min(1, container.clientWidth / WIDGET_WIDTH));
      };
      const observer = new ResizeObserver(updateScale);
      observer.observe(container);
      return () => observer.disconnect();
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const container_0 = containerRef.current;
      if (!container_0) {
        return;
      }
      if (typeof IntersectionObserver === "undefined") {
        const frame = requestAnimationFrame(() => setIsNearViewport(true));
        return () => cancelAnimationFrame(frame);
      }
      const observer_0 = new IntersectionObserver(t5 => {
        const [entry] = t5;
        if (entry.isIntersecting) {
          setIsNearViewport(true);
          observer_0.disconnect();
        }
      }, {
        rootMargin: "200px"
      });
      observer_0.observe(container_0);
      return () => observer_0.disconnect();
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[4] !== onExpire) {
    t5 = () => {
      const form = containerRef.current?.closest("form");
      const resetCaptcha = () => {
        widgetRef.current?.reset();
        onExpire?.();
      };
      form?.addEventListener("reset", resetCaptcha);
      return () => form?.removeEventListener("reset", resetCaptcha);
    };
    t6 = [onExpire];
    $[4] = onExpire;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  const t7 = WIDGET_HEIGHT * scale;
  let t8;
  if ($[7] !== t7) {
    t8 = {
      height: t7
    };
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = `scale(${scale})`;
  let t10;
  if ($[9] !== t9) {
    t10 = {
      transform: t9
    };
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== isNearViewport || $[12] !== onExpire || $[13] !== onSuccess || $[14] !== siteKey) {
    t11 = isNearViewport ? <Turnstile ref={widgetRef} siteKey={siteKey} options={{
      size: "normal",
      responseFieldName: "captcha_token"
    }} onSuccess={onSuccess} onExpire={onExpire} onError={onExpire} /> : null;
    $[11] = isNearViewport;
    $[12] = onExpire;
    $[13] = onSuccess;
    $[14] = siteKey;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11) {
    t12 = <div className="w-75 origin-top-left" style={t10}>{t11}</div>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t8) {
    t13 = <div ref={containerRef} className="w-full max-w-75 overflow-hidden" style={t8}>{t12}</div>;
    $[19] = t12;
    $[20] = t8;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
}